import { ContentType, request } from "../api";
import { baseParams } from "../common";

export const book = async (data = {}, params = {}) => request({
  path: "/book",
  method: "POST",
  secure: true,
  body: { ...baseParams, ...data },
  type: ContentType.Json,
  format: "json",
  ...params,
});
